<template>
  <kst-page-print-details page-footer
    class="has-text-weight-semibold ks-font-lucida-console print-thermal-size"
    @init="handleInit"
  >
    <template #page-footer="{ label, timestamp }">
      {{ label }} {{ timestamp }}
    </template>

    <Company class="block mb-6" :data="companyData" :customData="details"/>
    <Details :details="details"/>

    <kst-divider class="has-background-black"/>
    <Items :items="details.Items"/>

    <kst-divider class="has-background-black"/>
    <Total :details="details"/>
    <Footer :companyData="companyData"/>
  </kst-page-print-details>
</template>

<script>
import Model from "../InvModel.js";
import Services from "../../../services/Api/InvoiceServices.js";

import Details from "./InvPT_Details.vue";
import Total from "./InvPT_Total.vue";
import Items from "./InvPT_Items.vue";
import Footer from "./InvPT_Footer.vue";
import Company from "../../Company/RelatedPrintThermal/CpPT.vue";

export default {
  components: {
    Details,
    Footer,
    Items,
    Total,
    Company
  },
  data: () => ({
    companyData: {},
    details: {}
  }),
  methods: {
    /*** by page ***/

    handleInit(id, loadPrint) {
      this.resetData();

      const config = Services.getPrintThermalData(id);
      loadPrint(config, this.handleInit_Success);
    },
    handleInit_Success(data) {
      this.companyData = data.CompanyDetails;
      this.details = data.Details;

      Model.PrintThermal.updateDetails(this.details);
      Model.PrintThermal.updateItems(this.details.Items);

      for (const item of this.details.Items) {
        Model.updateItem(item);
      }
    },

    /*** custom ***/

    resetData() {
      this.companyData = {};
      this.details = {};
    }
  }
}
</script>

<style scoped lang="css" src="./_layout.css"/>